module.exports = __webpack_public_path__ + "static/media/game-cloud-icon.40a98132.png";